import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { products } from "./ProductData";
import { useCart } from "../../cart/CartContext";
import { toast } from "react-toastify";
import "./ProductDetail.css";
import { getProductImages } from "../../Components/ProductImages";
import {
  CURRENCY,
  getVariantPrices,
  getDefaultVariant,
  getPrice,
  formatPrice,
} from "./Prices";

export default function ProductDetail() {
  const { id } = useParams();
  const product = products.find((p) => p.id === id);

  const { addItem } = useCart();

  const sizeOptions = getVariantPrices(id);

const defaultSize = getDefaultVariant(id);
const [selectedSize, setSelectedSize] = useState(defaultSize);

const productImages = getProductImages(id, selectedSize);
const [selectedImage, setSelectedImage] = useState(
  productImages.heroImage
);

useEffect(() => {
  setSelectedSize(defaultSize);
}, [id, defaultSize]);

useEffect(() => {
  setSelectedImage(productImages.heroImage);
}, [id, selectedSize, productImages.heroImage]);

  const AMAZON_SERUM_URL = "https://www.amazon.com/dp/B0GWYFHN6G?th=1";

  const isSerum =
    product &&
    (
      product.id?.toLowerCase().includes("serum") ||
      product.name?.toLowerCase().includes("serum")
    );

  const handleAddToCart = () => {
    if (!product) return;

    const price = getPrice(product.id, selectedSize);
    if (price == null) {
      toast.error("Price is missing for this variant.", { autoClose: 1800 });
      return;
    }

    addItem({
      id: `${product.id}-${selectedSize}`,
      name: `${product.name} – ${selectedSize}`,
      price,
      currency: CURRENCY,
      image:
  selectedImage ||
  productImages.heroImage ||
  product.heroImage,
      quantity: 1,
    });

    toast.success(`${product.name} (${selectedSize}) added to cart 🛒`, {
      autoClose: 1800,
    });
  };

  if (!product) {
    return (
      <main style={{ padding: 40, maxWidth: 900, margin: "0 auto" }}>
        <h1>Product not found</h1>
        <Link to="/products">← Back</Link>
      </main>
    );
  }

  return (
    <main style={{ padding: "40px 20px", maxWidth: 1100, margin: "0 auto" }}>
      <div
        className="product-detail-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "1.25fr 1fr",
          gap: 24,
        }}
      >
        {/* IMAGE + GALLERY */}
        <div>
          <div
            style={{
              border: "1px solid rgba(0,0,0,0.06)",
              borderRadius: 16,
              overflow: "hidden",
              marginBottom: 12,
              background: "#f7f7f7",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: 420,
            }}
          >
            <img
              src={selectedImage}
              alt={product.name}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                display: "block",
                transition: "0.25s ease",
              }}
            />
          </div>

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {productImages.gallery.map((g, i) => {
              const isActive = selectedImage === g;
              return (
                <button
                  key={i}
                  type="button"
                  onClick={() => setSelectedImage(g)}
                  style={{
                    padding: 0,
                    borderRadius: 10,
                    border: isActive
                      ? "2px solid #000"
                      : "1px solid rgba(0,0,0,0.12)",
                    overflow: "hidden",
                    cursor: "pointer",
                    background: "transparent",
                  }}
                >
                  <img
                    src={g}
                    alt=""
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: "cover",
                      display: "block",
                      opacity: isActive ? 1 : 0.9,
                    }}
                  />
                </button>
              );
            })}
          </div>
        </div>

        {/* BUY BOX */}
        <div
          className="buy-box"
          style={{
            border: "1px solid rgba(0,0,0,0.08)",
            borderRadius: 16,
            padding: 20,
            background: "#fff",
            position: "sticky",
            top: 20,
          }}
        >
          <h1 style={{ marginTop: 0 }}>{product.name}</h1>

          <p style={{ color: "#444" }}>{product.shortDescription}</p>

          {/* SIZE SELECTOR */}
          <div style={{ marginTop: 20 }}>
            <strong style={{ display: "block", marginBottom: 6 }}>
              Select size:
            </strong>

            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              {Object.keys(sizeOptions).map((size) => {
                const isSelected = selectedSize === size;
                return (
                  <button
                    key={size}
                    onClick={() => setSelectedSize(size)}
                    style={{
                      padding: "10px 16px",
                      borderRadius: 10,
                      border: isSelected
                        ? "2px solid #000"
                        : "1px solid rgba(0,0,0,0.3)",
                      background: isSelected ? "#000" : "#fff",
                      color: isSelected ? "#fff" : "#000",
                      cursor: "pointer",
                      fontWeight: 600,
                      letterSpacing: 0.4,
                      transition: "0.15s",
                    }}
                  >
                    {size}
                  </button>
                );
              })}
            </div>
          </div>

          {/* PRICE */}
          <div
            style={{
              marginTop: 18,
              fontSize: "1.3rem",
              fontWeight: 600,
            }}
          >
            {formatPrice(getPrice(product.id, selectedSize), CURRENCY)}
          </div>

          {/* BUTTONS */}
          <div style={{ marginTop: 25 }}>
            <button
              onClick={handleAddToCart}
              style={{
                width: "100%",
                padding: "12px 18px",
                borderRadius: 12,
                border: "1px solid #000",
                background: "#000",
                color: "#fff",
                fontWeight: 600,
                fontSize: "0.95rem",
                letterSpacing: 0.3,
                cursor: "pointer",
                transition: "0.2s",
              }}
            >
              Add to Cart
            </button>

            {/* OR */}
            <div
              style={{
                marginTop: 18,
                marginBottom: 6,
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                color: "#777",
                fontSize: "0.85rem",
                fontWeight: 500,
              }}
            >
              <div style={{ height: 1, background: "#ddd", flex: 1 }}></div>
              <span>or</span>
              <div style={{ height: 1, background: "#ddd", flex: 1 }}></div>
            </div>

            {/* BUY ON ETSY */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 6,
                width: "100%",
              }}
            >
              <span
                style={{
                  color: "#555",
                  fontSize: "0.9rem",
                  fontWeight: 500,
                }}
              >
                Buy on
              </span>

              <a
                href={product.etsyUrl}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "12px 16px",
                  borderRadius: 12,
                  background: "#fff",
                  border: "1px solid #ccc",
                  width: "100%",
                  maxWidth: 260,
                  gap: 10,
                  textDecoration: "none",
                  fontWeight: 600,
                  color: "#333",
                  transition: "0.2s",
                }}
              >
                <img
                  src="https://shippingeasy.com/wp-content/uploads/2019/03/Etsy-Logo.png"
                  alt="Etsy logo"
                  style={{ height: 20 }}
                />
              </a>
            </div>

            {/* BUY ON AMAZON - SERUM ONLY */}
            {isSerum && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 6,
                  width: "100%",
                  marginTop: 12,
                }}
              >
                <span
                  style={{
                    color: "#555",
                    fontSize: "0.9rem",
                    fontWeight: 500,
                  }}
                >
                  Buy on
                </span>

                <a
                  href={AMAZON_SERUM_URL}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "12px 16px",
                    borderRadius: 12,
                    background: "#fff",
                    border: "1px solid #ccc",
                    width: "100%",
                    maxWidth: 260,
                    gap: 10,
                    textDecoration: "none",
                    fontWeight: 600,
                    color: "#333",
                    transition: "0.2s",
                  }}
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
                    alt="Amazon logo"
                    style={{ height: 22 }}
                  />
                </a>
              </div>
            )}
          </div>


        </div>
      </div>

      {/* SECTIONS */}
      <section style={{ marginTop: 40 }}>
        <h2>Key Features</h2>
        <ul style={{ marginTop: 10 }}>
          {product.keyFeatures.map((f, i) => (
            <li key={i}>{f}</li>
          ))}
        </ul>
      </section>

      <section style={{ marginTop: 40 }}>
        <h2>How to use</h2>
        <ul style={{ marginTop: 10 }}>
          {product.howToUse.map((step, i) => (
            <li key={i}>{step}</li>
          ))}
        </ul>
      </section>

      <section style={{ marginTop: 40 }}>
        <h2>Full INCI</h2>
        <ul style={{ marginTop: 10 }}>
          {product.inci.map((i, idx) => (
            <li key={idx}>{i}</li>
          ))}
        </ul>
      </section>

      <section style={{ marginTop: 40 }}>
        <h2>What’s NOT in it</h2>
        <ul style={{ marginTop: 10 }}>
          {product.whatsNotIn.map((w, idx) => (
            <li key={idx}>{w}</li>
          ))}
        </ul>
      </section>

      <section style={{ marginTop: 40 }}>
        <h2>Safety Notes</h2>
        <ul style={{ marginTop: 10 }}>
          {product.safetyNotes.map((s, idx) => (
            <li key={idx}>{s}</li>
          ))}
        </ul>
      </section>

      <section style={{ marginTop: 40 }}>
        <h2>Scientific Background</h2>
        <p>
          {product.scienceSection.summary}{" "}
          <a
            href={product.scienceSection.studyUrl}
            target="_blank"
            rel="noreferrer"
          >
            Read the study
          </a>
        </p>
        <p>
          Watch explanation:{" "}
          <a
            href={product.scienceSection.videoUrl}
            target="_blank"
            rel="noreferrer"
          >
            {product.scienceSection.videoTitle}
          </a>
        </p>
      </section>

      <section style={{ marginTop: 30, marginBottom: 40 }}>
        <Link to="/products">← Back to products</Link>
      </section>
    </main>
  );
}